"use strict";

var _interopRequireDefault = require("C:/Users/sandy/Desktop/EIOSYS/Admin/Alembic-Grow-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _interopRequireWildcard2 = _interopRequireDefault(require("C:/Users/sandy/Desktop/EIOSYS/Admin/Alembic-Grow-Admin/node_modules/@babel/runtime/helpers/interopRequireWildcard.js"));
var _index = _interopRequireDefault(require("@/layout/index.vue"));
const employeesRouter = {
  path: '/employees',
  component: _index.default,
  redirect: 'employees',
  name: 'Employees',
  meta: {
    title: 'employees.title',
    icon: 'user'
  },
  children: [{
    path: 'list',
    component: () => Promise.resolve().then(() => (0, _interopRequireWildcard2.default)(require( /* webpackChunkName: "admins-list" */'@/views/employees/list.vue'))),
    name: 'Employees',
    meta: {
      title: 'employees.title',
      noCache: true,
      icon: 'user'
    }
  }, {
    path: 'login',
    component: () => Promise.resolve().then(() => (0, _interopRequireWildcard2.default)(require( /* webpackChunkName: "admins-list" */'@/views/employee-login/login-form.vue'))),
    name: 'Employees Login',
    meta: {
      title: 'employees.login',
      noCache: true,
      icon: 'user'
    }
  }]
};
var _default = exports.default = employeesRouter;